'use client';

import { ServerActionName } from '@headless-workspace/config';
import { AsyncData, ResultEmpty, ResultFailure } from '@headless-workspace/core-domain';
import { UserRevalidationKey, useSafeSWR } from '@headless-workspace/domain/common/client';
import { getNewsletterSlotServerAction, NewsletterValue } from '../../../../server/lib/newsletter';

type NewsletterReturnType = AsyncData<NewsletterValue>;

const NEWSLETTER_DEFAULT_ERROR = 'NEWSLETTER ERROR';

export const useNewsletter = (): NewsletterReturnType => {
    const { data, isLoading, error } = useSafeSWR(
        UserRevalidationKey.NewsletterSlot,
        ServerActionName.getNewsletterSlot,
        getNewsletterSlotServerAction,
        // These options make the data immutable, meaning it will not be revalidated after the first fetch
        // See the last section of https://swr.vercel.app/fr-FR/docs/revalidation for more details
        {
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
        },
    );

    if (!data) {
        if (error) {
            return {
                isLoading,
                result: ResultFailure(NEWSLETTER_DEFAULT_ERROR, error instanceof Error ? error.message : undefined),
            };
        }

        return { isLoading, result: ResultEmpty() };
    }

    return { isLoading, result: data };
};
